module.exports = __webpack_public_path__ + "img/dash-user.6b85611d.svg";